import React from 'react'
import { useHistory } from 'react-router-dom'
import { Col, Grid, Row } from 'react-bootstrap'
import ActivityTable from '../ActivityTable/ActivityTable'
import { SectionTitle } from '../../../../../../Components/Section/SectionTitle'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'

const ActivitySection = ({ match, missions, isLoaded, deleteMission }) => {
  const history = useHistory()

  const spyDataMapper = spyData => {
    const data = spyData.map(mission => ({
      ...mission,
      timeStart: mission.timeRangeStart,
    }))

    return data
  }

  let spyActivities = spyDataMapper(missions)

  return (
    <AmbassadorSection className="no-padding overflow-auto">
      <Grid fluid>
        <Row className="padding-row">
          <Col xs={12}>
            <SectionTitle>Activity</SectionTitle>
          </Col>
        </Row>
        {missions.length ? (
          <Row>
            <Col xs={12} className="full-width-table">
              <ActivityTable
                history={history}
                match={match}
                spyActivities={spyActivities}
                deleteMission={deleteMission}
              />
            </Col>
          </Row>
        ) : isLoaded ? (
          <p className="not-found">No activities found</p>
        ) : (
          <p className="not-found">Loading</p>
        )}
      </Grid>
    </AmbassadorSection>
  )
}

export default ActivitySection
